import React from 'react';
import { useTranslation } from 'react-i18next';

export const STANDARD_PAGINATOR_TEMPLATE =
  'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport';

export const STANDARD_PAGE_REPORT_TEMPLATE = '{first}-{last} / {totalRecords}';

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50, 100];

export const PaginatorRowsLabel = () => {
  const { t } = useTranslation();

  return <span className="table-paginator-label">{t('table.rowsPerPage')}</span>;
};
